import { useQuery } from '@tanstack/react-query';
import { fetchStudyAnalytics } from '../api/studyAnalytics';
import { useCertStore } from '../stores/certStore';

export function useStudyAnalytics() {
  const certCode = useCertStore((s) => s.certCode);
  return useQuery({
    queryKey: ['study-analytics', certCode],
    queryFn: () => fetchStudyAnalytics(certCode),
    staleTime: 60_000,
  });
}
